import { sdkRequest } from '@eventbrite/http';

export interface IVerifyEmailWithCodeResponseApi {
    [x: string]: any;
}

// todo
export const VERIFY_CODE_URL = '/api/v3/users/validate_verification_code/';

export const verifyEmailWithCode = ({
    email,
    target,
    verificationCode,
}: {
    email: string;
    target: string;
    verificationCode: string;
}) => {
    return sdkRequest(VERIFY_CODE_URL, {
        method: 'POST',
        body: JSON.stringify({
            email,
            target_flow: target,
            verification_code: verificationCode,
        }),
    })
        .then((response: IVerifyEmailWithCodeResponseApi) => response)
        .catch((error: any) => {
            // return Promise.resolve();
            const statusCode = error.response ? error.response.status : 400;
            if (statusCode === 200) {
                // 200 Code It's Ok
                return Promise.resolve();
            } else {
                throw error;
            }
        });
};
